import { render, staticRenderFns } from "./GenFAB.vue?vue&type=template&id=4b776f3d&scoped=true&"
import script from "./GenFAB.vue?vue&type=script&lang=js&"
export * from "./GenFAB.vue?vue&type=script&lang=js&"
import style0 from "./GenFAB.vue?vue&type=style&index=0&id=4b776f3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b776f3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpeedDial,VTooltip})
